import { get as _get } from 'lodash';
import { prettifySize } from 'utils/prettify';
import * as _ from 'lodash';

// const selectButtonWidth = '64px';
const priceSheetWidth = '250px';
const whenWidth = '156px';
const createdByWidth = '130px';
const stateWidth = '80px';
const itemsWidth = '65px';
const assetsWidth = '70px';
const fitmentsWidth = '84px';
const receiversWidth = '89px';
const downloadWidth = '46px';
/* eslint-disable */
// const fileNameWidth = `calc(100% - ${selectButtonWidth} - ${priceSheetWidth} - ${whenWidth} - ${createdByWidth} - ${itemsWidth} - ${assetsWidth} - ${fitmentsWidth} - ${downloadWidth})`;
const fileNameWidth = `calc(100% - ${priceSheetWidth} - ${whenWidth} - ${createdByWidth} - ${stateWidth} - ${itemsWidth} - ${assetsWidth} - ${fitmentsWidth} - ${downloadWidth} - ${receiversWidth})`;
/* eslint-enable */

export const columns: any = [
  {
    title: 'File Name',
    width: fileNameWidth,
    sortable: true,
    sortName: 'user_filename',
    sort: 'desc',
    active: false,
    col: 'user_filename',
    link: false,
    textEllipsis: true,
  },
  {
    title: 'Price sheet(s)',
    width: priceSheetWidth,
    sortName: 'price_sheet_numbers',
    sort: 'desc',
    active: false,
    col: 'price_sheet_numbers',
    data: (row: any) => {
      const priceSheetNumbers = _.get(row, 'price_sheet_numbers');
      return _.join(priceSheetNumbers, ', ');
    }
  },
  {
    title: 'Created by',
    width: createdByWidth,
    sortable: true,
    sortName: 'createdBy',
    sort: 'desc',
    active: false,
    col: 'user.full_name',
    textEllipsis: true,
    data: (row: any) => {
      let value = _.get(row, 'user.full_name', '');
      value = _.get(row, 'export_schedule.name', value);
      return value;
    }
  },
  {
    title: 'Status',
    width: stateWidth,
    sortable: true,
    sortName: 'state',
    sort: 'desc',
    active: false,
    col: 'state',
    textEllipsis: true,
    data: (row: any) => {
      switch (_.get(row, 'state')) {
        case 1:
          return 'Working';
        case 2:
          return 'Published';
        default:
          return '';
      }
    },
  },
  {
    title: 'Items',
    width: itemsWidth,
    sortable: true,
    sortName: 'item_count',
    sort: 'desc',
    active: false,
    col: 'item_count',
    textEllipsis: true,
  },
  {
    title: 'Fitments',
    width: fitmentsWidth,
    sortable: true,
    sortName: 'app_count',
    sort: 'desc',
    active: false,
    col: 'app_count',
    textEllipsis: true,
  },
  {
    title: 'Assets',
    width: assetsWidth,
    sortable: true,
    sortName: 'asset_count',
    sort: 'desc',
    active: false,
    col: 'asset_count',
    textEllipsis: true,
  },
  {
    title: 'Receivers',
    width: receiversWidth,
    sortable: true,
    sortName: 'receivers',
    sort: 'desc',
    active: false,
    col: 'receivers',
    link: true,
    textEllipsis: true,
    data: (row: any) => {
      const receivers = _.get(row, 'receivers_data');
      if (!receivers || !receivers.length) { return null; }
      return receivers.length;
    }
  },
  {
    title: 'When',
    width: whenWidth,
    sortable: true,
    sortName: 'created_at',
    sort: 'desc',
    active: false,
    col: 'created_at',
    type: 'date',
    textEllipsis: true,
  },
  {
    title: 'Download',
    width: downloadWidth,
    sortable: false,
    active: false,
    col: 'download',
    icon: 'download-icon',
    align: 'right',
    textEllipsis: true,
  },
];
